import { trpc } from "@/lib/trpc";

export type TimePickerIncrement = 1 | 5;

export function resolveTimePickerIncrement(increment?: number): TimePickerIncrement {
  return increment === 5 ? 5 : 1;
}

export function useTimePickerIncrement(): TimePickerIncrement {
  const incrementQuery = trpc.preferences.timePickerIncrement.useQuery();
  return resolveTimePickerIncrement(incrementQuery.data?.increment);
}
